import * as ko from "knockout";
import {MutableAbstract, template as tpl} from "./MutableAbstract";
import {IExportFlowMutable} from "../../index";
import {nsExportTemplate} from "../../fn";
import {IComboboxV2Options} from "../../../combobox/v2";
import {createServiceListPromise} from "../../../combobox/v2-sources";
import {IExportAttribute, IExportFlow, ISearchParams, ISyncField} from "../../../../index";
import {global, lm} from "../../../../appContext";
import {nsSyncFields} from "../../../../req/nsSyncFields";
import {nsTooltip} from "../../../../util/nsTooltip";
import {getSourceTranslation} from "../../../../util/misc";
import {SyncstepId} from "../../../../constants";
import tpl_importHtml from './tpl_import.html?raw';

export const template = tpl
    .replace('<!-- {{TEMPLATE_TABLE}} -->', tpl_importHtml);

export class viewModel extends MutableAbstract {
    protected readonly type = 'import';
    protected data: KnockoutComputed<IExportFlowMutable[]> = ko.pureComputed((): IExportFlowMutable[] => {
        return this._data().filter((item: IExportFlowMutable) => nsExportTemplate.isExportFlowMutableOrdinaryImport(item));
    });

    protected createExportFlowMutable() {
        super._createExportFlowMutable(true);
    }

    private getComboboxParams_src(obj: IExportFlowMutable): IComboboxV2Options<IExportAttribute> {
        const objecttype = this.objecttype();
        const syncstep = this.syncstep();
        const listSource = createServiceListPromise<IExportAttribute>({
            name: 'getexportattributes',
            params: {
                syncstepid: syncstep?.syncstep.id ?? 0,
                objecttypeid: objecttype?.id ?? 0,
            } as unknown as ISearchParams,
        })
        return {
            prepareData: {
                filter: o => this.isExportAttributeOrdinaryType(o),
            },
            inputAttrs: {placeholder: lm.t('choose subject|s:((source|td|ac))')},
            initialMatch: o => (obj.sourceattribute()?.name ?? obj.sourceattribute()) == o.name,
            selected: obj.sourceattribute,
            promise: listSource.promise,
            onDispose: listSource.onDispose,
            option: {
                label: o => o.name,
                tooltip: o => o ? lm.t(nsTooltip.getTitle_exportAttribute(o) ?? '') : '',
            },
            inputStatus: (selected) => selected ? 'ok' : 'warning',
            // Many mapping rows mount at once on edit; defer option DOM until first open.
            lazyMountList: true,
            virtualize: true,
        }
    }

    private getComboboxParams_trg(obj: IExportFlowMutable): IComboboxV2Options<ISyncField> {
        const objecttype = this.objecttype();
        const listSource = createServiceListPromise<ISyncField>({
            name: 'getsyncfields',
            params: () => nsSyncFields.getSyncfieldsRequestParams(objecttype?.id) as unknown as ISearchParams,
        })
        return {
            inputAttrs: {placeholder: lm.t('choose subject|s:((target|td|ac))')},
            initialMatch: o => (obj.targetattribute()?.name ?? obj.targetattribute()) == o.name,
            option: {
                label: o => o?.name ? getSourceTranslation(o) : '',
                tooltip: o => o ? lm.t(nsTooltip.getTitle_syncfield(o) ?? '') : '',
            },
            promise: listSource.promise,
            onDispose: listSource.onDispose,
            selected: obj.targetattribute,
            reloadWhen: global.sourceTranslation,
            inputStatus: (selected) => selected ? 'ok' : 'warning',
            // Many mapping rows mount at once on edit; defer option DOM until first open.
            lazyMountList: true,
            virtualize: true,
        }
    }

    protected override showSection(key: keyof IExportFlow): boolean {
        switch (key) {
            case "nullable":
            case "sourceattribute":
            case "syncnext":
                return this.exporttemplate.syncstep()?.syncstep.id != SyncstepId.Synchronization
            default:
                return true
        }
    }

}